
import { SWRConfiguration, SWRResponse } from "swr";

import { GetNotesResponse, GetTrialNotes, UpdatedNoteEvent } from "@/api/dtos";
import { AppSettings } from "@/AppSettings";
import useGet from "@/hooks/api/useGet";
import { HubConnection } from "@microsoft/signalr/dist/esm";
import { useCallback, useMemo } from "react";
import useSignalROnMessage from "../api/useSignalROnMessage";

const getData = (response?: SWRResponse<GetNotesResponse, GetNotesResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetNotesResponse, GetNotesResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetNotesResponse, GetNotesResponse>) => ({});

export const useTrialNotesAndQueries = (trialId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!trialId) {
            return undefined;
        }

        return () => {
            return new GetTrialNotes({ trialId });
        }
    }, [trialId]);

    const output = useGet(request, { getData, getError, getAdditionalState }, configuration);

    const onMessage = useCallback(async (connection: HubConnection, data: UpdatedNoteEvent) => {
        if (
            trialId === data.trialId
        )
        {
            await output.refresh();
        }

    }, [
        output.refresh, 
        trialId
    ]);

    useSignalROnMessage(AppSettings.channels.note, onMessage);

    return output;
}

export default useTrialNotesAndQueries;